module.exports = __webpack_public_path__ + "img/MenuActive.de598f70.svg";